import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCalendarModule } from 'ng-zorro-antd/calendar';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzRateModule } from 'ng-zorro-antd/rate';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzTransferModule } from 'ng-zorro-antd/transfer';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NgDragDropModule } from 'ng-drag-drop';
import { DelonACLModule } from '@delon/acl';
import { ImagePickerModule } from 'ng-zorro-antd-mobile';
import { ConvertFloatPipe } from '../pipe/convert-float.pipe';

@NgModule({
  declarations: [
    ConvertFloatPipe
  ],
  imports: [
  ],
  exports: [
    CommonModule,
    DelonACLModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NzButtonModule,
    NzInputModule,
    NzLayoutModule,
    NzModalModule,
    NzCalendarModule,
    NzTableModule,
    NzBadgeModule,
    NzFormModule,
    NzDatePickerModule,
    NzSpinModule,
    NzDividerModule,
    NzTreeSelectModule,
    NzListModule,
    NzUploadModule,
    NzSelectModule,
    NzTabsModule,
    NzStepsModule,
    NzInputNumberModule,
    NzMenuModule,
    NzCollapseModule,
    NzTagModule,
    NzEmptyModule,
    NzToolTipModule,
    NzIconModule,
    NzMessageModule,
    NzTimePickerModule,
    NzRateModule,
    NzImageModule,
    NzCheckboxModule,
    NzRadioModule,
    NzCardModule,
    NzDropDownModule,
    NzAvatarModule,
    NzCarouselModule,
    NzPopoverModule,
    NzPopconfirmModule,
    NzProgressModule,
    NzTreeModule,
    NzTransferModule,
    NzSwitchModule,
    ScrollingModule,
    NgDragDropModule,
    ImagePickerModule,
    ConvertFloatPipe
  ],
  providers: [
    NzNotificationService
  ],
})
export class ShareModule { }
